/**
* @description: 设备管理
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                <el-button
                    type="primary"
                    icon="Plus"
                    @click="$refs['addDevice'].open()"
                    >{{ t('deviceList.add') }}</el-button
                >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #created_at="{ row }">
                    {{ formatDisplayDate(row.created_at) || '-' }}
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="toDetail(scope.row)">{{ t('common.detail') }}</el-button>
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['addDevice'].open(scope.row)">{{ t('common.edit') }}</el-button>
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['addDevice'].open(scope.row, 'addKm')">{{ t('deviceList.addKm') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <EditDevice ref="addDevice" :title="state.title" :statusOptions="statusOptions" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated } from "vue";
import { useRouter } from "vue-router";
import EditDevice from "./components/deviceAdd.vue";

import { pageListApi, saveApi } from "@/api/system/device";
import { listToMap } from "@/utils/utils";
import { formatDisplayDate } from "@/utils/dateTime.js";
import { usePageI18n, t } from "@/composables/usePageI18n.js";
import { ElMessage } from "element-plus";
const myElementRef = ref();
const searchBox = ref();
const addDevice = ref();
const router = useRouter();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: t('common.all'), value: 99 },
    { label: t('status.available'), value: 1 },
    { label: t('status.warehouse'), value: 0 },
])

const searchData = reactive([
    {
        label: "设备名称",
        type: "input",
        value: "",
        placeholder: "",
        field: 'keywords'
    },
    {
        label: "機號",
        type: "input",
        value: "",
        placeholder: "",
        field: 'model'
    },
    {
        label: "状态",
        type: "select",
        children: statusOptions,
        value: 99,
        placeholder: "",
        defaultValue: 99,
        field: 'status',
        clearable: false
    },
]);

const state = reactive({
    title: "",
    loading: false,
    column: [
        {
            prop: "id",
            show: false,
            label: "设备ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },

        {
            prop: "code",
            show: true,
            label: "機號",
            width: 250,
        },
        {
            prop: "title",
            show: true,
            label: "设备名称",
            width: 250,
        },
        // {
        //     prop: "name",
        //     show: true,
        //     label: "品牌",
        // },
        {
            prop: "model",
            show: true,
            label: "机型",
            width: 250,
        },
        {
            prop: "manufacturer",
            show: true,
            label: "厂商",
            width: 120,
        },
        {
            prop: "btitle",
            show: true,
            label: "模板",
            width: 180,
        },
        {
            prop: "kilometer",
            show: true,
            label: "公里数",
            width: 80,
        },
        {
            prop: "time",
            show: true,
            label: "工作时长",
            width: 120,
        },
        {
            prop: "chu_kilometer",
            show: true,
            label: "初始公里数",
            width: 80,
        },
        {
            prop: "chu_time",
            show: true,
            label: "初始工作时长",
            width: 120,
        },
        {
            prop: "created_at",
            show: true,
            label: "初始保养时间",
            width: 120,
        },
        {
            prop: "status",
            show: true,
            label: "状态",
            width: 60
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 260
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
    //     {
    //     "code": "vfe15616516n",
    //     "device_id": 1,
    //     "updated_at": "2025-05-10 21:36:43",
    //     "kilometer": 0,
    //     "name": "标题",
    //     "created_at": "2025-05-10 21:36:43",
    //     "btitle": "模板",
    //     "model": "332123",
    //     "id": 1,
    //     "title": "云吊",
    //     "status": 1
    // }
    ]
});

const init = () => {
    getSearch(searchData)
};

const toDetail = (row, tab = "info") => {
    router.push({
        path: "/equipment/device-detail",
        query: { id: row.id, tab },
    });
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        applyLabels();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    state.loading = true
    const requestParams = JSON.stringify({
        page: page.value,
        limit: limit.value,
        ...listToMap(params, { value: 'value', key: 'field' })
    })
    pageListApi(requestParams).then(res => {
        if (res?.code !== 200) {
            maxPage.value = 0
            state.tableData = []
            ElMessage.warning(res?.msg || t('deviceList.loadFailed'))
            state.loading = false
            return
        }
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(i => {
            return {
                ...i,
                status: listToMap(statusOptions, { })[i.status] ?? '',
            }
        }) ?? []
        state.loading = false
    }).catch(e => {
        maxPage.value = 0
        state.tableData = []
        ElMessage.error(t('deviceList.loadFailed'))
        state.loading = false
    })
};

// 表头筛选
const applyLabels = () => {
    searchData[0].label = t('field.deviceName');
    searchData[1].label = t('field.deviceCode');
    searchData[2].label = t('field.status');
    statusOptions[0].label = t('common.all');
    statusOptions[1].label = t('status.available');
    statusOptions[2].label = t('status.warehouse');
    state.column[1].label = t('table.index');
    state.column[2].label = t('field.deviceCode');
    state.column[3].label = t('field.deviceName');
    state.column[4].label = t('field.model');
    state.column[5].label = t('field.manufacturer');
    state.column[6].label = t('field.template');
    state.column[7].label = t('field.kilometer');
    state.column[8].label = t('deviceList.workDuration');
    state.column[9].label = t('field.initialKilometer');
    state.column[10].label = t('field.initialWorkHours');
    state.column[11].label = t('field.maintenanceTime');
    state.column[12].label = t('field.status');
    state.column[13].label = t('table.operation');
    tableHeaderFn();
};

usePageI18n(applyLabels);

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
